import PartySocket from 'partysocket';
import { useStore, type RemoteState } from './store';
import { play as playSfx } from './audio';

let socket: PartySocket | null = null;

export function connect(
  roomId: string,
  userName: string,
  initSettings?: { turnTimeLimit: 30 | 60 | 90 | 120; allowJokerInInitialMeld: boolean; timeoutPenalty: 1 | 3 },
) {
  const { userId } = useStore.getState();
  sessionStorage.setItem('userName', userName);
  localStorage.setItem('userName', userName);
  useStore.setState({ userName });

  const host =
    (import.meta.env.VITE_PARTYKIT_HOST as string | undefined) ??
    (location.hostname === 'localhost' ? 'localhost:1999' : `${location.hostname}`);

  const query: Record<string, string> = { userId, name: userName, avatar: '' };
  if (initSettings) {
    query.turnTimeLimit = String(initSettings.turnTimeLimit);
    query.allowJokerInInitialMeld = String(initSettings.allowJokerInInitialMeld);
    query.timeoutPenalty = String(initSettings.timeoutPenalty);
  }

  socket = new PartySocket({
    host,
    room: roomId,
    party: 'room',
    query,
  });

  useStore.getState().setError('連線中…');
  socket.addEventListener('open', () => {
    useStore.getState().setConnected(true);
    useStore.getState().setError(null);
  });
  socket.addEventListener('close', (ev) => {
    useStore.getState().setConnected(false);
    if (!useStore.getState().remote) {
      useStore.getState().setError(`連線關閉 code=${(ev as CloseEvent).code}`);
    }
  });
  socket.addEventListener('error', (ev) => {
    console.error('WS error', ev);
    useStore.getState().setError('WebSocket 連線失敗，請檢查 server 狀態');
  });
  socket.addEventListener('message', (ev) => {
    const msg = JSON.parse(ev.data);
    console.log('[WS]', msg.type, msg);
    if (msg.type === 'stateSync') {
      const prev = useStore.getState().remote;
      const next = msg.state as RemoteState;
      // 偵測狀態變化播放音效
      const myId = useStore.getState().userId;
      const wasMyTurn = prev?.currentTurnPlayerId === myId;
      const isMyTurn = next.currentTurnPlayerId === myId;
      if (!wasMyTurn && isMyTurn && next.status === 'PLAYING') playSfx('turnStart');
      if (prev && prev.players.length < next.players.length) playSfx('playerJoin');
      useStore.getState().setRemote(next);
    } else if (msg.type === 'error') {
      console.error('server error', msg);
      playSfx('tileInvalid');
      useStore.getState().setError(`${msg.code}${msg.message ? ': ' + msg.message : ''}`);
      setTimeout(() => useStore.getState().setError(null), 5000);
    } else if (msg.type === 'gameOver') {
      const myId = useStore.getState().userId;
      const me = msg.results.find((r: { userId: string }) => r.userId === myId);
      if (me?.isWinner && msg.results.filter((r: { isWinner: boolean }) => r.isWinner).length === 1) playSfx('gameWin');
      else if (me?.isWinner) playSfx('gameDraw');
      else playSfx('gameLose');
      useStore.getState().setGameOver({ trigger: msg.trigger, results: msg.results });
    } else if (msg.type === 'kicked') {
      alert('此帳號於其他裝置登入，本連線已中斷');
      location.reload();
    }
  });
}

export function send(type: string, payload?: Record<string, unknown>) {
  if (!socket) { console.warn('[WS] no socket for', type); return; }
  if (socket.readyState !== WebSocket.OPEN) { console.warn('[WS] socket not open, state=', socket.readyState, 'for', type); return; }
  console.log('[WS] send', type, payload);
  socket.send(JSON.stringify({ type, ...payload }));
}

export function disconnect() {
  socket?.close();
  socket = null;
}
